import {CircleModel} from '../../models/api/circleModel';
import {CompanyModel} from '../../models/api/companyModel';
import {deleteAsync} from '../../services/http/http';
import {ListMutation} from '../helpers/listMutation';
import {ResourceTableCommonPageType} from '../helpers/resourceListPagination/resourceListPaginationHelpers';

/*
 * Types.
 */

export type CircleListPageType = ResourceTableCommonPageType<CircleModel>;

export enum CircleMutationsEnum {
  DELETE = 'delete',
}

interface DeleteMutationAction {
  type: CircleMutationsEnum.DELETE;
  payload: {
    company: CompanyModel;
    circleIds: ReadonlyArray<number>;
  };
}

export type CircleListMutation = DeleteMutationAction;

/*
 * Mutations.
 */

const deleteCircleMutation: ListMutation<CircleListPageType, DeleteMutationAction, void> = {
  mutationKey: CircleMutationsEnum.DELETE,

  runSideEffect: async (payload) => {
    const {circleIds, company} = payload;

    if (circleIds.length === 0) {
      return;
    }

    await deleteAsync(`${company.url}/circles_batch`, {circle_ids: circleIds});
  },

  runOptimisticUpdate: (data, payload) => {
    const {circleIds} = payload;

    return {
      ...data,
      items: data.items.filter((item) => !circleIds.includes(item.id)),
    };
  },
};

export const circleListMutations = [deleteCircleMutation] as const;
